// ═══ 인보이스 계산/행 생성 순수 함수 ═══
// useInvoiceState에서 분리. 모든 함수는 인자만 의존, 부수 효과 없음.
import { getYearFromVin } from './vinDecoder';

// 행 id 생성 — Date.now()만 쓰면 ms 단위 충돌 가능. counter 결합으로 보장.
var _rowIdCounter = 0;
function nextRowId() {
  _rowIdCounter = (_rowIdCounter + 1) % 1000000;
  return Date.now() * 1000 + _rowIdCounter;
}

// invoice currency에 맞춰 단일 통화로 표시할 가격 문자열
// row._carInvAmt(KRW invoice_amount) / _carUsd / _carKrw 캐시 사용
export function pickPriceStr(row, invCur) {
  if (!row) return '';
  if (invCur === 'KRW') {
    if (row._carInvAmt > 0) return String(row._carInvAmt);
    if (row._carKrw > 0) return String(row._carKrw);
    return '';
  }
  if (row._carUsd > 0) return String(Math.round(row._carUsd));
  return '';
}

// 차량(또는 null)을 carRow로 변환
export function makeRow(c, currency) {
  var _vy = c ? getYearFromVin(c.vin, c.regDate ? parseInt(c.regDate.slice(0, 4)) : null) : null;
  var _invCur = currency || 'KRW';
  var row = {
    id: c ? c.id : nextRowId(),
    carId: c ? c.id : 0,
    carNo: c ? c.carNo || '' : '',
    carType: c ? c.carType || '' : '',
    year: _vy ? String(_vy) : (c && c.regDate ? c.regDate.slice(0, 4) : ''),
    vin: c ? c.vin || '' : '',
    priceKrw: c ? c.buyPrice || 0 : 0,
    _carInvAmt: c && c.invoice_amount > 0 ? c.invoice_amount : 0,
    _carUsd: c && c.sell_price_usd > 0 ? c.sell_price_usd : 0,
    _carKrw: c ? c.buyPrice || 0 : 0,
    priceCurrency: _invCur,
    weight: '',
    photo: null,
    photoUrl: '',
  };
  row.price = pickPriceStr(row, _invCur);
  return row;
}

// 빈 row (addRow에서 사용)
export function makeEmptyRow() {
  return {
    id: nextRowId(),
    carId: 0,
    carNo: '',
    carType: '',
    year: '',
    vin: '',
    priceKrw: 0,
    price: '',
    priceCurrency: 'KRW',
    weight: '',
    photo: null,
    photoUrl: '',
  };
}

// 통화 변환: amt(fromCur) → invoice currency
export function makeToInvCur(currency, exchangeRate, usdToKrw) {
  return function (amt, fromCur) {
    if (!amt) return 0;
    if (fromCur === currency) return amt;
    if (currency === 'KRW' && fromCur === 'USD') {
      return usdToKrw > 0 ? Math.round(amt * usdToKrw) : 0;
    }
    if (currency === 'KRW' && fromCur !== 'KRW') {
      return usdToKrw > 0 ? Math.round(amt * usdToKrw) : 0;
    }
    if (!exchangeRate || exchangeRate <= 0) return 0;
    if (fromCur === 'KRW' && currency !== 'KRW') return Math.round(amt / exchangeRate);
    if (fromCur !== 'KRW' && currency === 'KRW') return Math.round(amt * exchangeRate);
    return amt;
  };
}

// 합계 계산: carRows + freight + insurance → totalAmt/totalWeight/grandTotal
export function calcTotals(carRows, freight, freightCurrency, insurance, insuranceCurrency, currency, toInvCur) {
  var totalAmt = carRows.reduce(function (s, r) {
    var raw = parseInt(String(r.price).replace(/[^0-9]/g, '')) || 0;
    return s + toInvCur(raw, r.priceCurrency || currency);
  }, 0);
  var totalFreightInv = toInvCur(parseInt(freight) || 0, freightCurrency);
  var totalInsuranceInv = toInvCur(parseInt(insurance) || 0, insuranceCurrency);
  var totalWeight = carRows.reduce(function (s, r) {
    return s + (parseInt(String(r.weight).replace(/[^0-9]/g, '')) || 0);
  }, 0);
  var grandTotal = totalAmt + totalFreightInv + totalInsuranceInv;
  return {
    totalAmt: totalAmt,
    totalFreightInv: totalFreightInv,
    totalInsuranceInv: totalInsuranceInv,
    totalWeight: totalWeight,
    grandTotal: grandTotal,
  };
}

// cross-tenant initCars 필터 — doc_agency 예외
export function filterInitCars(rawInitCars, curUserCid, isDocAgency) {
  if (!rawInitCars || rawInitCars.length === 0) return [];
  return rawInitCars.filter(function (c) {
    if (!c || c.companyId === undefined) return true;
    return curUserCid === 0 || isDocAgency || c.companyId === curUserCid;
  });
}
